import util from '../../lib/util';
import store from '../store';
import Actions from '../actions/indexExport';
import {getCurrentUserId} from '../../lib/picos/currentLogin';
import newHRTimestamp from '../../lib/picos/timestamp';
import {findAll} from "../find";
import Privilege from '../../entities/privilege';
import Role from '../../entities/role';

/*
 * Delete/nullify anywhere this privilege is used in other entities
 *
 * @param {Privilege} privilege
 */
export function deletePrivilege(privilege: Privilege, mergeId?: string) {
    let targetImportSource = 'merge';

    if (!mergeId) {
        targetImportSource = 'delete';
        mergeId = privilege.id;
    }
    /* Simple delete usages */
        
    store.getState().roles
        .getMappingFor('privilegeId', privilege.id)
        .filter(roleTemp => roleTemp.status !== 'D')
        .forEach(roleTemp => {
            const _role = roleTemp.clone();
            _role.status =  'U';
            _role.addedOn = newHRTimestamp();
            _role.importSource = targetImportSource;
            _role.importId = mergeId;

            _role.privileges = _role.privileges?.filter(id => id !== privilege.id) || [];
            store.dispatch(Actions.RoleActions.saveRoleQueue(_role));
        });

    /* Remove the actual privilege */
    privilege.status = 'D';
    privilege.addedOn = newHRTimestamp();
    privilege.addedBy = getCurrentUserId();
    privilege.importSource = targetImportSource;
    privilege.importId = mergeId;
    store.dispatch(Actions.PrivilegeActions.removePrivilegeQueue(privilege));
    
}

/*
 * Replace anywhere this privilege is used in other entities.
 *
 * @param {Privilege} privilege
 * @param {Privilege} replaceWith
 * @return {Privilege} - Privilege will have refs stripped away
 */
export function replacePrivilege(privilege: Privilege, replaceWith: Privilege, mergeId?: string) {
    let targetImportSource = 'merge';

    if (!mergeId) {
        targetImportSource = 'delete';
        mergeId = privilege.id;
    }
    /* Simple replace usages */
        
    store.getState().roles
        .getMappingFor('privilegeId', privilege.id)
        .filter(roleTemp => roleTemp.status !== 'D')
        .forEach(roleTemp => {
            const _role = roleTemp.clone();
            _role.status =  'U';
            _role.addedOn = newHRTimestamp();
            _role.importSource = targetImportSource;
            _role.importId = mergeId;

            _role.privileges = _role.privileges?.map(id => (id === privilege.id) ? replaceWith.id : id) || [];
            store.dispatch(Actions.RoleActions.saveRoleQueue(_role));
        });

    return privilege;
}

/*
 * Determine the impact of deleting this privilege from other entities
 *
 * @param {Privilege} privilege
 * @return {Array.<{count: number, entity: string}>} - a list of impacted entities, along with a count of impacted entities
 */
export function deleteImpactPrivilege(privilege: Privilege) {
    const impacts: string[] = [];
    const state = store.getState();
    
    /* Simple delete usages */
        
    const rolePrivilegesImpact = state.roles
          .getMappingFor('privilegeId', privilege.id)
          .filter(role => role.status !== 'D');

    rolePrivilegesImpact.forEach(() => impacts.push('roles'));

    return util.countDistinct(impacts);
}